export default "__VITE_ASSET__Dj3ZRF0K__"